var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3521_49490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.75 0.375H2.25C1.21447 0.375 0.375 1.21447 0.375 2.25V45.75C0.375 46.7855 1.21447 47.625 2.25 47.625H45.75C46.7855 47.625 47.625 46.7855 47.625 45.75V2.25C47.625 1.21447 46.7855 0.375 45.75 0.375Z",
    stroke: "#D2D2D2",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 10.2344H14.8158C14.0928 10.237 13.4003 10.5262 12.8904 11.0387C12.3804 11.5512 12.0945 12.2451 12.0955 12.9681L12.082 34.8344C12.081 35.5574 12.3669 36.2513 12.8769 36.7638C13.3868 37.2763 14.0793 37.5655 14.8023 37.5681H31.2175C31.9418 37.5658 32.6357 37.2769 33.1477 36.7648C33.6597 36.2526 33.9484 35.5586 33.9505 34.8344V18.4349L25.75 10.2344ZM31.2175 34.8344H14.8158V12.9681H24.382V19.8021H31.216L31.2175 34.8344Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2463 26.8852C16.5334 26.8852 16.7661 26.6525 16.7661 26.3655C16.7661 26.0784 16.5334 25.8457 16.2463 25.8457C15.9593 25.8457 15.7266 26.0784 15.7266 26.3655C15.7266 26.6525 15.9593 26.8852 16.2463 26.8852Z",
    fill: "#1A1A1A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.8958,
    height: 13.854,
    transform: "translate(5.67578 19.6973)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7623 24.546H16.2425V21.9473H10.0048V24.546H9.48503C9.28019 24.5457 9.07729 24.5858 8.88798 24.6641C8.69867 24.7424 8.52666 24.8572 8.38182 25.002C8.23697 25.1469 8.12213 25.3189 8.04387 25.5082C7.96562 25.6975 7.92549 25.9004 7.92578 26.1053V29.2223H10.0048V31.3013H16.2425V29.2223H18.3215V26.1053C18.3218 25.9004 18.2817 25.6975 18.2034 25.5082C18.1252 25.3189 18.0103 25.1469 17.8655 25.002C17.7207 24.8572 17.5486 24.7424 17.3593 24.6641C17.17 24.5858 16.9671 24.5457 16.7623 24.546ZM11.0443 22.9868H15.2008V24.546H11.0443V22.9868ZM15.2008 29.2223V30.2618H11.0443V28.185H15.2008V29.2223ZM16.2403 28.1828V27.1455H10.0048V28.185H8.96528V26.1053C8.96665 25.9678 9.02185 25.8364 9.11903 25.7393C9.2162 25.6421 9.34761 25.5869 9.48503 25.5855H16.76C16.8975 25.5869 17.0289 25.6421 17.126 25.7393C17.2232 25.8364 17.2784 25.9678 17.2798 26.1053V28.1843L16.2403 28.1828Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3521_49490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.3028470ebd90f8dba39cc4b3150040db.svg";
export { ForwardRef as ReactComponent };